import { TemplateElement, html, defineElement } from '@webtides/element-js';
import style from './story-benefit-teaser.css';
import '../story-benefit/story-benefit.js';
import '../../../tab-group/tab-group.js';
import '../../../tab-link/tab-link.js';
import '../../../tab-panel/tab-panel.js';

let componentId = 0;

export default class StoryBenefitTeaser extends TemplateElement {
    constructor() {
        super({ styles: [style] });
        this.componentId = `story-benefit-teaser-${componentId++}`;
    }

    properties() {
        return {
            headline: '',
            items: [],
        };
    }

    template() {
        const items = Array.isArray(this.items) ? this.items : [];
        const tabClasses =
            'block w-full border-0 border-solid border-l-2 pl-16 m-0 cursor-pointer text-left font-medium text-xl leading-[1.4] md:text-lg md:leading-[1.5] lg:text-xl lg:leading-[1.4] xl:text-2xl xl:leading-[1.3] transition-colors duration-200 border-transparent text-[var(--mdx-sys-color-primary-subtle4)] hover:text-white [&[active]]:border-white [&[active]]:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white';

        return html`
            <div
                class="group/section container-full bg-[linear-gradient(90deg,var(--mdx-sys-color-primary-default,#144b3c)_0%,#000_100%)]"
                data-surface="dark"
            >
                <div class="container story-benefit-teaser-container">
                    <div
                        class="flex flex-col w-full mx-auto py-48 md:py-56 lg:py-56 xl:py-80 gap-32 md:gap-48 xl:gap-56 xl:max-w-[1130px]"
                    >
                        <h2
                            class="flex-headline3-medium w-full m-0 text-center text-white"
                        >
                            ${this.headline}
                        </h2>
                        <mb-tab-group update-url="false" class="block pb-0">
                            <div
                                class="flex flex-col md:flex-row items-stretch md:items-center md:justify-center lg:justify-start w-full gap-40 lg:gap-48"
                            >
                                <div
                                    class="flex flex-col min-w-0 gap-24 md:gap-32 md:basis-[208px] md:shrink-0 lg:flex-1 lg:basis-0"
                                    role="tablist"
                                    aria-label="${this.headline}"
                                    aria-orientation="vertical"
                                >
                                    ${items.map(
                                        (item, index) => html`
                                            <mb-tab-link
                                                for="${this.componentId}-${index}"
                                                variant="none"
                                                class="${tabClasses}"
                                                >${item?.headline || ''}</mb-tab-link
                                            >
                                        `,
                                    )}
                                </div>
                                <div
                                    class="min-w-0 w-full md:shrink-0 md:basis-[472px] lg:basis-[calc(50%+155px)] xl:basis-[calc(50%+170px)]"
                                >
                                    ${items.map(
                                        (item, index) => html`
                                            <mb-tab-panel name="${this.componentId}-${index}" class="min-w-0 w-full">
                                                <mb-story-benefit
                                                    class="text-white"
                                                    text="${item?.text || ''}"
                                                    .image=${item?.image}
                                                    video="${item?.video || ''}"
                                                    .riveAnimation=${item?.riveAnimation}
                                                    .notification=${item?.notification}
                                                    .link=${item?.link || null}
                                                ></mb-story-benefit>
                                            </mb-tab-panel>
                                        `,
                                    )}
                                </div>
                            </div>
                        </mb-tab-group>
                    </div>
                </div>
            </div>
        `;
    }
}

defineElement('mb-story-benefit-teaser', StoryBenefitTeaser);
